import React from 'react';
import styled from 'styled-components';
import {useBoundStore} from "../../stores/useBoundStore";

const Holder = styled.div`
  position: relative;
  width: 100%;
  align-self: start;
  opacity: ${props => props.isAnimating ? 0.2 : 1};
  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: var(--color-2);
  }
`;
const Inner = styled.div.attrs(props => ({
  style: {
    gridTemplateColumns: `${props.xCols.join('% ')}%`,
  }
}))`
  display: grid;
  width: 100%;
`;
const Column = styled.div`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    z-index: 10;
    bottom: 0;
    left: 2px;
    right: 2px;
    height: 2px;
    background-color: var(--color-1);
  }
  p {
    ${(props) => props.theme.fluidType(-1)};
    line-height: 1;
    margin: 0 0 0.5rem 0;
  }
`;

function XRuler() {
  const {xCols, animation} = useBoundStore(state => state);
  const trimPercent = (val) => {
    return `${parseFloat(val).toFixed(0)}%`
  }
  return (
    <Holder isAnimating={animation !== 'noAnimation'}>
      <Inner xCols={xCols}>
        <Column>
          <p>A <br/>{trimPercent(xCols[0])}</p>
        </Column>
        <Column>
          <p>B <br/>{trimPercent(xCols[1])}</p>
        </Column>
        <Column>
          <p>C <br/>{trimPercent(xCols[2])}</p>
        </Column>
        <Column>
          <p>D <br/>{trimPercent(xCols[3])}</p>
        </Column>
      </Inner>
    </Holder>
  )
}

export default XRuler;